module.exports = __webpack_public_path__ + "img/icon_code.55bd02f3.png";